import { initialAction, initialState } from './initial';

type Reducer = (
  state: typeof initialState,
  action: typeof initialAction,
) => typeof initialState;

const reducer: Reducer = (state, action) => {
  const { type, payload } = action ?? {};

  switch (type) {
    case 'UPDATE_USER_AVATAR':
    case 'UPDATE_USER_FIRST_NAME':
    case 'UPDATE_USER_DISPLAY_NAME': {
      return {
        ...state,
        ...payload,
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer };
